import React, { useState } from 'react';
import { useAddVan, useFetchVan } from './vans.hooks';
import { useParams,useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Paper,
  FormLabel 
} from '@mui/material';

import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { constants } from '../../constants';
export default function AddVanPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [fieldErrors, setFieldErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    id: id,
  });


  const {
    data: vanData,
    isLoading: isFetching,
    isError
  } = useFetchVan(id);


 if(isError){
    dispatch(showAlert({
      severity: constants.ERROR,
      title: 'Failed to load van data',
    }));
  }

  const { mutate, isLoading: isSubmitting } = useAddVan();

  React.useEffect(() => {
    if (vanData) {
      setFormData({
        name: vanData.name,
        username: vanData.username,
        password: '', 
        id: vanData.id,
        
      });
    }
  }, [vanData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.name.trim()) errors.name = ['Van Name is required.'];
    if (!formData.username.trim()) errors.username = ['Username is required.'];
    if (!isEdit && !formData.password.trim()) errors.password = ['Password is required.'];
  
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      return; // Stop here, don’t submit to API
    }
  
    setFieldErrors({});
  
    mutate(formData, {
      onSuccess: () => {
        dispatch(showAlert({
          severity: constants.SUCCESS,
          title: `Van ${isEdit ? 'updated' : 'added'} successfully`,
        }));
        navigate('/vans/manage');
      },
      onError: (error) => {
        if (
          error?.response?.status === 422 &&
          error?.response?.data?.errors
        ) {
          setFieldErrors(error.response.data.errors);
        } else {
          dispatch(showAlert({
            severity: constants.ERROR,
            title: error?.response?.data?.message || 'Something went wrong',
          }));
        }
      },
    });
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 400, mx: 'auto', mt: 6 }}>
      <Typography variant="h5" gutterBottom>
        {isEdit ? 'Edit Van' : 'Add Van'}
      </Typography>

      {isFetching ? (
        <Box display="flex" justifyContent="center" my={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            label="Van Name"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={formData.name}
            error={!!fieldErrors.name}
            helperText={fieldErrors.name?.[0]} // always access index 0
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            label="Username"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={formData.username}
            error={!!fieldErrors.username}
            helperText={fieldErrors.username?.[0]} // always access index 0
            onChange={(e) => setFormData({ ...formData, username: e.target.value })}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={formData.password}
            error={!!fieldErrors.password}
            helperText={fieldErrors.password?.[0]}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          />
          {isEdit && (
            <FormLabel sx={{ mt: 1 }}>
              * Leave empty if you don't want to update the password
            </FormLabel>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? <CircularProgress size={24} /> : isEdit ? 'Update Van' : 'Add Van'}
          </Button>

        </Box>
      )}
    </Paper>
  );
}
